import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import Scroll from 'react-scroll-to-element';
import { navigate } from 'gatsby';
import styled, { withTheme } from 'styled-components';
import { LanguagePicker, toggleSlideMenu, Icons } from '@wingscms/crane';
import routing from '../../../../services/routing';
import chaptersImage from '../../../img/chapters.svg';
var Container = styled.div.withConfig({
  displayName: "CornerMenu__Container",
  componentId: "sc-9ksimy-0"
})(["position:fixed;display:block;bottom:0;right:0;height:50px;z-index:20;background-color:", ";box-shadow:", ";&.hidden{display:none;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.defaultShadow;
});
var ChaptersLink = styled.a.withConfig({
  displayName: "CornerMenu__ChaptersLink",
  componentId: "sc-9ksimy-1"
})(["background-color:", ";height:50px;width:", ";display:inline;font-weight:bold;color:", ";font-size:18px;float:left;text-decoration:none;text-align:center;position:relative;transition:0.15s linear all;cursor:pointer;box-shadow:", ";&.divider{border-right:2px solid #000;}span{line-height:50px;vertical-align:middle;display:", ";}&:hover,&:active{background-color:", ";}@media screen and (max-width:800px){width:65px;span{display:none;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.languagePickerColor;
}, function (_ref4) {
  var slideMenu = _ref4.slideMenu;
  return slideMenu ? '65px' : '270px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.textColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.defaultShadow;
}, function (_ref7) {
  var slideMenu = _ref7.slideMenu;
  return slideMenu ? 'none' : 'initial';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.languagePickerHoverColor;
});
var ChapterImage = styled.img.withConfig({
  displayName: "CornerMenu__ChapterImage",
  componentId: "sc-9ksimy-2"
})(["vertical-align:", ";margin:", ";@media screen and (max-width:800px){vertical-align:initial;margin-top:25px;margin-right:23px;}"], function (_ref9) {
  var slideMenu = _ref9.slideMenu;
  return slideMenu ? 'initial' : 'middle';
}, function (_ref10) {
  var slideMenu = _ref10.slideMenu;
  return slideMenu ? '25px 25px 0 20px' : '0 0 3px 20px';
});
var ShareLink = styled.a.withConfig({
  displayName: "CornerMenu__ShareLink",
  componentId: "sc-9ksimy-3"
})(["width:50px;height:50px;padding:15px;background-color:", ";display:block;position:relative;transition:all 0.15s linear;cursor:pointer;svg{fill:", ";}&:hover{background-color:", ";&:last-of-type{&:after{border-color:", " transparent transparent transparent;}}}&:last-of-type{&:after{content:'';position:absolute;top:100%;left:50%;transition:all 0.15s linear;border-color:", " transparent transparent transparent;transform:translateX(-50%);border-style:solid;border-width:10px;height:0;width:0;display:inline-block;}}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.primaryColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.cornerMenuIconColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.secondaryColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.secondaryColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.primaryColor;
});
var ShareOpen = styled.div.withConfig({
  displayName: "CornerMenu__ShareOpen",
  componentId: "sc-9ksimy-4"
})(["height:50px;width:50px;background-color:", ";display:inline;float:right;position:relative;overflow:visible;transition:all 0.15s linear;cursor:pointer;box-shadow:", ";.linkWrapper{width:100%;background-color:transparent;display:none;cursor:default;height:160px;}&:hover,&:active{background-color:", ";.linkWrapper{display:block;}}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.primaryColor;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.defaultShadow;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.primaryColor;
});
var ShareIconWrapper = styled.div.withConfig({
  displayName: "CornerMenu__ShareIconWrapper",
  componentId: "sc-9ksimy-5"
})(["padding:17px 17px 7px 17px;svg{fill:", ";}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.cornerMenuIconColor;
});
var ShareOpenInner = styled.div.withConfig({
  displayName: "CornerMenu__ShareOpenInner",
  componentId: "sc-9ksimy-6"
})(["width:100%;position:absolute;bottom:0;left:0;"]);
var LanguagePickerWrap = styled.div.withConfig({
  displayName: "CornerMenu__LanguagePickerWrap",
  componentId: "sc-9ksimy-7"
})(["display:inline-block;margin:0;width:250px;height:50px;z-index:5;position:relative;border-bottom:3px solid #eee;> div{> div{&.translations{height:auto;> div{color:#000 !important;}}height:50px;}}svg{margin-left:12px;}"]);

var CornerMenu =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(CornerMenu, _Component);

  function CornerMenu(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleScroll = function () {
      var hidden = _this.state.hidden;

      if (window.scrollY > 200 && hidden) {
        _this.setState({
          hidden: false
        });
      }

      if (window.scrollY < 200 && !hidden) {
        _this.setState({
          hidden: true
        });
      }
    };

    _this.state = {
      url: '',
      hidden: true
    };
    return _this;
  }

  var _proto = CornerMenu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      url: encodeURIComponent("http://" + window.location.hostname + window.location.pathname)
    });
    window.addEventListener('scroll', this.handleScroll);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        chapterMenu = _this$props.chapterMenu,
        _this$props$chapters = _this$props.chapters,
        chapters = _this$props$chapters === void 0 ? [] : _this$props$chapters,
        chaptersTitle = _this$props.chaptersTitle,
        locale = _this$props.locale,
        shareMessage = _this$props.shareMessage,
        _this$props$translati = _this$props.translations,
        translations = _this$props$translati === void 0 ? [] : _this$props$translati,
        theme = _this$props.theme;
    var _this$state = this.state,
        hidden = _this$state.hidden,
        url = _this$state.url;
    var windowExists = typeof window !== 'undefined';
    return React.createElement(Container, {
      className: hidden ? 'hidden' : ''
    }, translations.length > 0 ? React.createElement(LanguagePickerWrap, null, React.createElement(LanguagePicker, {
      showAbove: true,
      backgroundColor: theme.languagePickerColor,
      backgroundHoverColor: theme.languagePickerHoverColor,
      translations: translations.map(function (t) {
        return {
          name: t.locale.name,
          locale: t.locale.id,
          node: t
        };
      }),
      current: {
        locale: locale.id,
        name: locale.name
      },
      onTranslationClick: function onTranslationClick(_ref20) {
        var node = _ref20.node;
        navigate(routing.getPath(node));
      }
    })) : null, chapters.length > 0 ? windowExists && translations.length < 1 && (!chapterMenu || chapterMenu !== 'slide') ? React.createElement(Scroll, {
      type: "id",
      element: "chapter-list"
    }, React.createElement(ChaptersLink, null, chaptersTitle, React.createElement(ChapterImage, {
      src: chaptersImage
    }))) : React.createElement(ChaptersLink, {
      className: translations.length > 0 ? 'divider' : '',
      slideMenu: true,
      onClick: function onClick(e) {
        e.preventDefault();
        toggleSlideMenu(document.getElementById('content-wrapper').classList.contains('chaptersOpen'), 'content-wrapper', 'chaptersOpen', false);
      }
    }, chaptersTitle, React.createElement(ChapterImage, {
      src: chaptersImage,
      slideMenu: true
    })) : null, React.createElement(ShareOpen, null, React.createElement(ShareOpenInner, null, React.createElement("div", {
      className: "linkWrapper"
    }, React.createElement(ShareLink, {
      href: "https://www.facebook.com/sharer/sharer.php?u=" + url,
      target: "_blank"
    }, React.createElement(Icons.Facebook, null)), React.createElement(ShareLink, {
      href: "https://twitter.com/intent/tweet?url=" + url + (shareMessage ? "&status=" + encodeURIComponent(shareMessage) + "%20" + url : ''),
      target: "_blank"
    }, React.createElement(Icons.Twitter, null)), React.createElement(ShareLink, {
      href: "whatsapp://send?text=" + (shareMessage ? encodeURIComponent(shareMessage) + ": " : '') + url,
      target: "_blank"
    }, React.createElement(Icons.Whatsapp, null))), React.createElement(ShareIconWrapper, null, React.createElement(Icons.Share, null)))));
  };

  return CornerMenu;
}(Component);

export default withTheme(CornerMenu);